import { render, staticRenderFns } from "./CalendarChevronDownIcon.vue?vue&type=template&id=39b548e9&scoped=true"
import script from "./CalendarChevronDownIcon.vue?vue&type=script&lang=ts"
export * from "./CalendarChevronDownIcon.vue?vue&type=script&lang=ts"
import style0 from "./CalendarChevronDownIcon.vue?vue&type=style&index=0&id=39b548e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b548e9",
  null
  
)

export default component.exports